import axios from 'axios'
import decode from 'jwt-decode'
import { v4 } from 'uuid'
import qs from 'qs'
import { validDistricts } from '../../common/validDistricts'

export class SSOService {
  constructor(config) {
    this.config = config
    this._bearerToken = null
    this._accessToken = null
    this._state = null
  }

  get bearerTokenSymbol() {
    return `${this.config.namespace}/bearer_token`
  }

  get accessTokenSymbol() {
    return `${this.config.namespace}/access_token`
  }

  get stateSymbol() {
    return `${this.config.namespace}/state`
  }

  get bearerToken() {
    if (this._bearerToken) {
      return this._bearerToken
    }
    this._bearerToken = localStorage.getItem(this.bearerTokenSymbol)
    return this._bearerToken
  }

  get accessToken() {
    if (this._accessToken) {
      return this._accessToken
    }
    this._accessToken = localStorage.getItem(this.accessTokenSymbol)
    return this._accessToken
  }

  get state() {
    if (this._state) {
      return this._state
    }
    this._state = localStorage.getItem(this.stateSymbol)
    return this._state
  }

  set bearerToken(token) {
    this._bearerToken = token
    localStorage.setItem(this.bearerTokenSymbol, token)
  }

  set accessToken(token) {
    this._accessToken = token
    localStorage.setItem(this.accessTokenSymbol, token)
  }

  set state(state) {
    this._state = state
    localStorage.setItem(this.stateSymbol, state)
  }

  drop() {
    localStorage.removeItem(this.bearerTokenSymbol)
    localStorage.removeItem(this.accessTokenSymbol)
    localStorage.removeItem(this.stateSymbol)
    this._bearerToken = null
    this._accessToken = null
    this._state = null
  }

  async login() {
    const { data } = await axios.get(
      `https://auth.${this.config.domain}/.well-known/openid-configuration`
    )
    const authorizationEndpoint = data.authorization_endpoint

    console.log(authorizationEndpoint)

    const state = v4()
    const nouce = v4()
    localStorage.setItem(`${this.config.namespace}/state`, state)

    const query = qs.stringify({
      client_id: this.config.client_id,
      response_type: 'code',
      redirect_uri: this.config.callbackUrl,
      scope: this.config.scope,
      state,
      nouce
    })

    location.href = `${authorizationEndpoint}?${query}`
  }

  logout() {
    const originalToken = encodeURIComponent(this.accessToken)

    this.drop()

    const query = qs.stringify({
      id_token_hint: originalToken,
      // TODO: set current host
      post_logout_redirect_uri: 'http://localhost:8080/login'
    })
    window.localStorage.removeItem('commando_mobile_district_id')
    window.location.href = `https://auth.${this.config.domain}/connect/endsession?${query}`
  }

  async exchangeToken(authorizationReponse) {
    const state = localStorage.getItem(this.stateSymbol)
    if (!state || !authorizationReponse.state) {
      this.drop()
      throw new Error('login failed')
    }
    if (state !== authorizationReponse.state) {
      this.drop()
      throw new Error('login failed')
    }
    localStorage.removeItem(this.stateSymbol)

    const token = new FormData()

    token.append('client_id', this.config.client_id)
    token.append('grant_type', 'authorization_code')
    token.append('code', authorizationReponse.code)
    token.append('redirect_uri', this.config.callbackUrl)

    const tokenResponse = await axios({
      url: `https://auth.${this.config.domain}/connect/token`,
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      data: token
    })

    const bearerResponse = await axios({
      url: `https://auth.${this.config.domain}/api/token/exchange/`,
      method: 'GET',
      headers: {
        authorization: `Bearer ${tokenResponse.data.access_token}`
      }
    })

    localStorage.setItem(
      this.accessTokenSymbol,
      tokenResponse.data.access_token
    )
    localStorage.setItem(
      this.bearerTokenSymbol,
      bearerResponse.data.access_token
    )
  }

  decodeUser() {
    return decode(this.bearerToken)
  }

  setDistrictId(user, store) {
    const isFromLocalStorage = window.localStorage.getItem(
      'commando_mobile_district_id'
    )
    const districtId = parseInt(
      isFromLocalStorage || user.defaultdistrictid,
      10
    )

    const districtIdIncludesInAcccess = id => {
      return store.getters['sso/districts'].map(x => x.districtId).includes(id)
    }

    const isValidDistrictId = districtIdIncludesInAcccess(districtId)

    if (districtId && isValidDistrictId) {
      store.commit('sso/SET_DEFAULT_DISTRICT', districtId)
    } else if (districtId && !isValidDistrictId) {
      const defaultDistrict = store.getters['sso/districts']
        .map(x => x.districtId)
        .find(x => validDistricts.includes(x))
      store.commit('sso/SET_DEFAULT_DISTRICT', defaultDistrict)
    } else {
      store.commit('sso/SET_DEFAULT_DISTRICT', null)
    }
  }
}
